import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'function',
  name: 'Function',
  category: 'utilities',
  description: 'Execute custom JavaScript code to transform data. Process all items at once or iterate per item with access to previous node outputs and workflow variables.',
  icon: 'FunctionSquare',
  color: 'purple',
  version: '1.0.0',

  group: ['transform'],

  defaults: {
    name: 'Function',
    color: '#a855f7',
  },

  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],

  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],

  tags: ['function', 'code', 'javascript', 'transform', 'custom', 'script'],

  metadata: {
    documentation: 'https://docs.n8n.io/integrations/builtin/core-nodes/n8n-nodes-base.code/',
  },
};

export default definition;
